import flush from 'just-flush';
import { defaultLanguage } from '@stereoagency/constants';
import { SyntheticEvent } from 'react';
import { PortableTextReactComponents } from '@portabletext/react';
import { createDocumentURL, findInKeyArray, sanityImageAsProps } from '@/utils';
import { researchGroupQuery } from './researchGroupQuery';
import { SimpleBlockContent } from '@/components/sanity/client';

const ptComponentsWithoutLink: Partial<PortableTextReactComponents> = {
  marks: { link: ({ children }) => children }
};

export default function entryAsCardProps(
  group: (typeof researchGroupQuery)[1][number],
  lang: string,
  onClick: (taxId: string) => void
) {
  const title = group.title
    ? findInKeyArray(group.title, [lang, defaultLanguage.id])
    : null;
  const description = group.introduction
    ? findInKeyArray(group.introduction, [lang, defaultLanguage.id])
    : null;
  const image = group.researchGroupLeader?.image;

  if (!title?.value || !image || !group.slug?.current) {
    return null;
  }

  return {
    color: '--colors-yellow-700',
    title: title.value,
    image: sanityImageAsProps(image),
    description: description?.value ? (
      <SimpleBlockContent
        value={description.value}
        components={ptComponentsWithoutLink}
      />
    ) : null,
    badges: flush(
      group.badges?.map((badge) => {
        if (!badge.image?.asset._ref) return null;
        return { image: sanityImageAsProps(badge.image) };
      }) ?? []
    ),
    action: {
      href: createDocumentURL(lang, 'researchGroup', group.slug.current)
    },
    tags: flush(
      group.taxonomies?.map((tax) => {
        const name = tax.name
          ? findInKeyArray(tax.name, [lang, defaultLanguage.id])
          : null;

        if (!name?.value || !tax.slug?.current) {
          return null;
        }

        return {
          label: name.value,
          href: `#${tax.slug.current}`,
          onClick(event: SyntheticEvent<HTMLAnchorElement>) {
            event.preventDefault();
            if (tax._id) {
              onClick(tax._id);
            }
          }
        };
      }) ?? []
    )
  };
}
